class ClickTracker {

	static name() {
		return 'ClickTracker';
	}

	constructor(props, el) {
		this.el = document;
		this.socialDomains = [
			'facebook.com',
			'twitter.com',
			'linkedin.com',
			'instagram.com',
			'youtube.com'
		];

		this.handleClick = this.handleClick.bind(this);
	}

	init() {
		this.el.addEventListener('click', this.handleClick);
		console.log('ClickTracker initialized');
	}

	handleClick(event) {
		
		var dataLayer;
		dataLayer = window.dataLayer || [];
		
		const target = event.target.closest('a, button');
		if (!target) return;

		const isInNavbar = !!target.closest('.navbar-brand, .navbar-nav');
		const isInFooter = !!target.closest('footer');
		const linkText = target.textContent.replace(/['\r\n]+/g, ' ').replace(/\s+/g, ' ').trim();
		const normalizedText = linkText.toLowerCase();
		const linkUrl = target.href || target.getAttribute('href') || '';
		const isAnchor = target.tagName.toLowerCase() === 'a';
		const isButton = target.tagName.toLowerCase() === 'button';
		const btnElement = target.closest('.btn');
		const isCTA = (isAnchor || isButton || btnElement) 
              && btnElement 
              && !normalizedText.includes('download');
		var isFileLink;
		let isInternal = false;
		try {
			const resolvedUrl = new URL(linkUrl, location.href);
			isFileLink = /\.[^./]+$/i.test(resolvedUrl.pathname) && !/\.html?$/i.test(resolvedUrl.pathname);
			isInternal = isAnchor && (resolvedUrl.hostname === location.hostname) && !isCTA  && !isInNavbar && !isInFooter;
		} catch (e) {
			// skip invalid URLs
		}

		// CTA Click
		if (isCTA && !isFileLink) {
			dataLayer.push({
				event: 'cta_click',
				link_text: linkText,
				link_url: linkUrl
			});
		} 
		
		// Social Media Exit
		else if (isAnchor && !isInternal && !isFileLink && this.socialDomains.some(domain => linkUrl.includes(domain))) {
			dataLayer.push({
				event: 'social_exit',
				link_text: linkText,
				link_url: linkUrl
			});
		}

		// Learn More
		else if ((isAnchor || isButton) && normalizedText === 'learn more') {
			dataLayer.push({
				event: 'learn_more',
				link_text: linkText,
				link_url: linkUrl
			});
		}

		// View Categories
		else if ((isAnchor || isButton) && normalizedText === 'view categories') {
			dataLayer.push({
				event: 'view_categories'
			});
		}

		// View Products
		else if ((isAnchor || isButton) && normalizedText === 'view products') {
			dataLayer.push({
				event: 'view_products'
			});
		}
		
		// Open click inside calculator
		else if (
			isAnchor &&
			normalizedText === 'open' &&
			target.closest('.js-calculator-container')
		) {
			this.pushEvent({
				event: 'calculator_open',
				link_text: linkText,
				link_url: linkUrl
			});
		}
		
		// Internal Link
		else if (isInternal && !isFileLink) {
			dataLayer.push({
				event: 'internal_click',
				link_text: linkText,
				link_url: linkUrl
			});
		}

	}
}

export default ClickTracker;
